export default __webpack_public_path__ + "static/technologyMobile-cee67e2aeb67ec638523eab41d924fa0.svg";